import React from "react";
import FeatureSessionStore from "../uidispatcherapi/FeatureSessionStore";
import { wrapLazily } from "../lazy-loading/lazyWrapper";
import { connectWithDefaultStores } from "../stores/stores";
import cx from "classnames";

const MetroXBrandBar = wrapLazily(() => import("explore_ui/MetroXBrandBar"), {
	usesBootstrap: true,
	usesMoment: false,
});

export const COMPANION_APP_USER_AGENT = "Companion";
type Props = {
	isNoHeader: () => boolean;
	isEmployee: () => boolean;
	history?: any;
};

const mobileBreakpoint = 768;
const SCROLL_TOP_THRESHOLD = 5;

export class DisconnectedPageHeader extends React.Component<Props> {
	scrollY: number = 0;

	state = {
		visible: true,
		isMobile: window.innerWidth < mobileBreakpoint,
		isProfileOpen: false,
	};

	isMetroX() {
		return FeatureSessionStore.getMembershipFor("METRO_X") === "B";
	}

	willNotShow() {
		const { isNoHeader, isEmployee } = this.props;
		const isCompanionApp = navigator.userAgent.includes(COMPANION_APP_USER_AGENT);
		const isCartOrCheckoutRoute =
			window.location.pathname.includes("/cart") || window.location.pathname.includes("/checkout");
		const isNarrowScreen = window.innerWidth < mobileBreakpoint;
		const isCustomer = !isEmployee();
		return (
			!this.isMetroX() ||
			isNoHeader() ||
			isCompanionApp ||
			(isCustomer && isNarrowScreen && isCartOrCheckoutRoute)
		);
	}

	bodyContainsMetroX() {
		return window.document.body.classList.contains("metrox");
	}

	handleScroll = () => {
		if (!this.state.isMobile) return;

		const currentScrollY = window.scrollY;
		const isVisible = currentScrollY <= SCROLL_TOP_THRESHOLD ? true : this.scrollY > currentScrollY;

		if (isVisible !== this.state.visible) {
			this.setState({ visible: isVisible });
		}

		this.scrollY = currentScrollY;
	};

	handleResize = () => {
		this.setState({
			isMobile: window.innerWidth < mobileBreakpoint,
		});
	};

	componentDidMount() {
		if (this.isMetroX() && !this.bodyContainsMetroX()) {
			window.document.body.classList.add("metrox");
		}
		this.scrollY = window.scrollY;
		window.addEventListener("scroll", this.handleScroll, { passive: true });
		window.addEventListener("resize", this.handleResize, { passive: true });
	}

	componentWillUnmount() {
		if (this.isMetroX()) {
			window.document.body.classList.remove("metrox");
		}
		window.removeEventListener("scroll", this.handleScroll);
		window.removeEventListener("resize", this.handleResize);
	}

	render() {
		const { isMobile, visible, isProfileOpen } = this.state;
		const isCartOrCheckoutRoute =
			window.location.pathname.includes("/cart") || window.location.pathname.includes("/checkout");

		const headerClass = cx("mfcss_header brandbar-container", {
			visible: isMobile && visible && !isCartOrCheckoutRoute && !isProfileOpen,
			"fake-hide": isMobile && !visible && !isCartOrCheckoutRoute,
			"is-cart-checkout-route": isCartOrCheckoutRoute,
		});

		if (this.willNotShow()) return null;

		return (
			<div className={headerClass} data-testid="page-header-container">
				<MetroXBrandBar className="test-metro-x-brandbar" forceFlyout history={this.props.history} />
			</div>
		);
	}
}

const wrapped = connectWithDefaultStores(
	{
		stores: {
			HeaderStore: (s: any) => ({
				isNoHeader: () => s.getIsNoHeader(),
			}),
			SessionStore: (s: any) => ({
				isEmployee: () => s.isEmployee(),
			}),
		},
	},
	DisconnectedPageHeader,
) as React.ComponentType<Omit<Props, "isNoHeader" | "isEmployee">>;

export default wrapped;
